import { render, staticRenderFns } from "./GoodsBrandList.vue?vue&type=template&id=216ec0aa&scoped=true&"
import script from "./GoodsBrandList.vue?vue&type=script&lang=js&"
export * from "./GoodsBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ec0aa",
  null
  
)

export default component.exports